export const isExternallyManagedOrganization = (managementSource: string | null | undefined): boolean =>
  managementSource === 'EXTERNAL';
